/* npx-pa-plats.js: sökning, filter och sortering byter rutnätet på startsidan utan sidbyte (Jacob 2026-10-19).

   Bara på startsidan (body[data-npx-sida="index"]); laddas av npx-explore.liquid efter npx-explore.js och bara där.
   Kollektionerna, /search och /collections/all skickar formuläret som förut.

   Så hänger det ihop:
   - Allt som ändrar resultatet landar i ett submit-event: bannerns sökruta (form.npx-sok), radens sökruta och
     knappen Visa (form#npx-facets), och npx-explore.js requestSubmit vid ett filterval eller en ny sortering.
     Här stoppas sidbytet (preventDefault) och samma adress som formuläret skulle ha gått till byggs av fälten:
     med sökord /search?q=…&view=npx&type=product&options[prefix]=last, utan sökord /collections/all?view=npx,
     i båda fallen med de ikryssade filtren och sort_by. Typknapparna Allt/Foto/Film under bannerns sökruta och
     spaltens kryssrutor för filter.p.product_type är samma val: knapparna kryssar rutorna, och efter svaret visar
     knapparna det som är aktivt i spalten.
   - Sidan hämtas med fetch och tolkas med DOMParser. window.npxExplore.ersatt(doc) (npx-explore.js) byter rutorna,
     antalet och nästa-länken; facetterna i spalten stäms av här, val för val, så att kryssrutan man just klickade på
     är samma element efteråt (fokus och panelen står kvar). Antalen per grupp i panelens spår uppdateras med
     window.npxPanel.uppdatera() (npx-panel.js).
   - Adressfältet får den hämtade adressen med history.replaceState (utan filter, sökord och sortering: startsidan),
     så att en omladdning eller en delad länk ger samma resultat från servern. popstate hämtar om när adressen ändras
     under sidans liv (till exempel bakåt förbi #npx-explore).
   - Fel (nätverk, 500, sidan saknar rutnätet): sidan laddas på adressen som vanligt, alltså samma som formuläret.
   - Under hämtningen: klassen npx-hamtar på sektionen (npx-pa-plats.css tonar rutnätet till 50 %) och aria-busy på
     rutnätet. Efteråt läser en aria-live-rad upp antalet ("175 klipp"). */
(function () {
  "use strict";
  if (!document.body || document.body.getAttribute("data-npx-sida") !== "index") return;
  var root = document.querySelector("[data-npx-explore]"),
    api = window.npxExplore,
    form = root && root.querySelector("form#npx-facets"),
    grid = root && root.querySelector("[data-npx-grid]");
  if (!root || !api || !form || !grid || !window.fetch || !window.DOMParser || !window.URLSearchParams || !history.replaceState) return;

  var TYP = "filter.p.product_type",
    MINNE = "npx-panel-efter-filter", // npx-panel.js: öppna panelen igen efter en omladdning. Behövs inte här.
    TOPP_STD = 53, // toppradens höjd när verktygsraden saknar top
    reducerad = window.matchMedia("(prefers-reduced-motion: reduce)"),
    coarse = window.matchMedia("(hover: none)").matches,
    sok = document.querySelector("form.npx-sok"),
    sokInp = sok && sok.querySelector('input[name="q"]'),
    typInp = document.getElementById("npx-intro-typ"),
    typGrupp = document.querySelector('[data-npx-val][data-target="npx-intro-typ"]'),
    barInp = form.querySelector('input[name="q"]'),
    sortSel = form.querySelector("select[name=sort_by]"),
    side = root.querySelector("[data-npx-side]"),
    main = root.querySelector(".npx-main") || form,
    go = form.querySelector(".npx-search__go"),
    allUrl = form.getAttribute("action"),
    sokUrl = (go && go.getAttribute("formaction")) || (sok && sok.getAttribute("action")) || "/search",
    hemUrl = allUrl.replace(/\/collections\/all\/?$/, "") || "/",
    senast = utanHash(location.href),
    nr = 0,
    ctrl = null;

  function utanHash(u) {
    return u.split("#")[0];
  }
  function slice(l) {
    return Array.prototype.slice.call(l);
  }
  function rutor() {
    return slice(form.elements).filter(function (el) {
      return el.type === "checkbox" && el.name;
    });
  }

  // ---- Upplästa antalet ----
  var live = document.createElement("p");
  live.className = "npx-visually-hidden";
  live.setAttribute("role", "status");
  live.setAttribute("aria-live", "polite");
  root.appendChild(live);
  function meddela(doc) {
    var c = doc.querySelector(".npx-count");
    live.textContent = "";
    c &&
      setTimeout(function () {
        live.textContent = c.textContent.replace(/\s+/g, " ").trim();
      }, 60);
  }

  // ---- Typknapparna (Allt/Foto/Film) och spaltens typrutor är samma val ----
  function visaTyp(v) {
    typInp && (typInp.value = v);
    typGrupp &&
      slice(typGrupp.querySelectorAll("button[data-v]")).forEach(function (b) {
        b.setAttribute("aria-pressed", b.getAttribute("data-v") === v ? "true" : "false");
      });
  }
  function typFranRutor() {
    var valda = rutor().filter(function (el) {
      return el.name === TYP && el.checked;
    });
    visaTyp(valda.length === 1 ? valda[0].value : "");
  }
  function kryssa(el, pa) {
    el.checked = pa;
    var chip = el.closest(".npx-chip");
    chip && chip.classList.toggle("is-active", pa);
  }

  // ---- Adressen som formuläret skulle ha gått till ----
  function adresser() {
    var q = (barInp ? barInp.value : sokInp ? sokInp.value : "").trim(),
      p = new URLSearchParams(),
      typer = [],
      finns = {};
    q && p.append("q", q);
    p.append("view", "npx");
    q && (p.append("type", "product"), p.append("options[prefix]", "last"));
    rutor().forEach(function (el) {
      el.name === TYP && (finns[el.value] = 1);
      el.checked && (el.name === TYP ? typer.push(el.value) : p.append(el.name, el.value));
    });
    // Ett typval från bannern utan motsvarande ruta i spalten (gruppen saknas i det senaste svaret)
    var tv = typInp ? typInp.value : "";
    tv && !finns[tv] && typer.indexOf(tv) < 0 && typer.push(tv);
    typer.forEach(function (v) {
      p.append(TYP, v);
    });
    var s = sortSel ? sortSel.value : "";
    s && p.append("sort_by", s);
    var hamta = (q ? sokUrl : allUrl) + "?" + p.toString();
    return { hamta: hamta, visa: p.toString() === "view=npx" ? hemUrl : hamta };
  }

  // ---- Facetterna stäms av mot svaret ----
  // Varje filtergrupp får en nyckel (kryssrutornas name) på både details och värdelistan, eftersom npx-panel.js
  // flyttar värdelistan in i panelen och en grupp kan bli tom.
  function nyckelAv(values) {
    var i = values.querySelector("input[name]");
    return i ? i.name : "";
  }
  (function marka() {
    if (!side) return;
    var utanLista = [];
    slice(side.querySelectorAll("details.npx-facet")).forEach(function (d) {
      var v = d.querySelector(":scope > .npx-facet__values"),
        k = v && nyckelAv(v);
      v ? k && (d.setAttribute("data-npx-nyckel", k), v.setAttribute("data-npx-nyckel", k)) : utanLista.push(d);
    });
    // en grupp vars lista redan ligger i panelen (panelen öppnades vid laddning)
    var kropp = side.querySelector("[data-npx-panel-kropp] > .npx-facet__values"),
      k = kropp && nyckelAv(kropp);
    k && utanLista.length === 1 && (utanLista[0].setAttribute("data-npx-nyckel", k), kropp.setAttribute("data-npx-nyckel", k));
  })();
  function stamLista(gammal, ny) {
    var finns = {},
      ordning = [];
    slice(gammal.querySelectorAll(":scope > .npx-chip")).forEach(function (l) {
      var i = l.querySelector("input");
      i ? (finns[i.value] = l) : l.remove();
    });
    (ny ? slice(ny.querySelectorAll(":scope > .npx-chip")) : []).forEach(function (nl) {
      var ni = nl.querySelector("input"),
        gl = ni && finns[ni.value];
      if (!ni) return;
      if (gl) {
        var gi = gl.querySelector("input"),
          ge = gl.querySelector("em"),
          ne = nl.querySelector("em");
        gi.checked !== ni.checked && (gi.checked = ni.checked);
        gi.disabled !== ni.disabled && (gi.disabled = ni.disabled);
        gl.className !== nl.className && (gl.className = nl.className);
        ge && ne && ge.textContent !== ne.textContent && (ge.textContent = ne.textContent);
        delete finns[ni.value];
        ordning.push(gl);
      } else ordning.push(document.importNode(nl, !0));
    });
    Object.keys(finns).forEach(function (k) {
      finns[k].remove();
    });
    // bara nya val sätts in; befintliga flyttas aldrig (en flyttad ruta tappar fokus)
    ordning.forEach(function (el, i) {
      gammal.children[i] !== el && gammal.insertBefore(el, gammal.children[i] || null);
    });
  }
  function stamFacetter(doc) {
    if (!side) return;
    var nya = {};
    slice(doc.querySelectorAll("details.npx-facet")).forEach(function (d) {
      var v = d.querySelector(".npx-facet__values"),
        k = v && nyckelAv(v);
      k && (nya[k] = d);
    });
    slice(side.querySelectorAll("details.npx-facet[data-npx-nyckel]")).forEach(function (d) {
      var k = d.getAttribute("data-npx-nyckel"),
        nd = nya[k] || null,
        lista = side.querySelector('.npx-facet__values[data-npx-nyckel="' + k.replace(/"/g, '\\"') + '"]');
      lista && stamLista(lista, nd && nd.querySelector(".npx-facet__values"));
      // antalet valda i gruppens rubrik
      var sum = d.querySelector(":scope > summary"),
        n = sum && sum.querySelector(".npx-facet__n"),
        nn = nd && nd.querySelector("summary .npx-facet__n");
      if (sum) {
        nn
          ? n
            ? (n.textContent = nn.textContent)
            : sum.appendChild(document.createTextNode(" ")) && sum.appendChild(document.importNode(nn, !0))
          : n && n.remove();
      }
      nn ? d.setAttribute("data-npx-keep", "") : d.removeAttribute("data-npx-keep");
    });
    var fn = root.querySelector("[data-npx-filter-n]"),
      nfn = doc.querySelector("[data-npx-filter-n]");
    fn && nfn && ((fn.textContent = nfn.textContent), (fn.hidden = nfn.hasAttribute("hidden")));
    window.npxPanel && window.npxPanel.uppdatera && window.npxPanel.uppdatera();
    typFranRutor();
  }

  // ---- Rullning ----
  function toppen() {
    var t = parseFloat(getComputedStyle(form).top);
    return t > 0 ? t : TOPP_STD;
  }
  function rullaTillRutnatet(bara_om_forbi) {
    var y = main.getBoundingClientRect().top - toppen();
    if (bara_om_forbi && y >= -1) return;
    Math.abs(y) >= 1 &&
      window.scrollTo({ top: Math.max(0, window.pageYOffset + y), behavior: reducerad.matches ? "auto" : "smooth" });
  }

  // ---- Hämtningen ----
  function klar() {
    root.classList.remove("npx-hamtar");
    grid.removeAttribute("aria-busy");
  }
  // url: sidan som hämtas. visa: adressen som skrivs i adressfältet (null = rör inte adressen, vid popstate).
  function hamta(url, visa, rulla) {
    var mitt = ++nr;
    ctrl && ctrl.abort();
    ctrl = window.AbortController ? new AbortController() : null;
    root.classList.add("npx-hamtar");
    grid.setAttribute("aria-busy", "true");
    return fetch(url, {
      headers: { "X-Requested-With": "fetch" },
      credentials: "same-origin",
      signal: ctrl ? ctrl.signal : void 0,
    })
      .then(function (r) {
        if (!r.ok) throw new Error("HTTP " + r.status);
        return r.text();
      })
      .then(function (html) {
        if (mitt !== nr) return;
        var doc = new DOMParser().parseFromString(html, "text/html");
        if (!doc.querySelector("[data-npx-explore] form#npx-facets")) throw new Error("sektionen saknas i svaret");
        if (api.ersatt(doc) < 0) throw new Error("rutnätet kunde inte bytas");
        stamFacetter(doc);
        visa && (history.replaceState(history.state, "", visa), (senast = utanHash(location.href)));
        try {
          sessionStorage.removeItem(MINNE);
        } catch (e) {}
        klar();
        meddela(doc);
        rulla === "om-forbi" && rullaTillRutnatet(!0);
      })
      .catch(function (err) {
        if (mitt !== nr || (err && err.name === "AbortError")) return;
        klar();
        // som formuläret: sidan laddas på adressen
        location.assign(visa || url);
      });
  }
  function kor(rulla) {
    var a = adresser();
    rulla === "fore" && rullaTillRutnatet(!1);
    return hamta(a.hamta, a.visa, rulla || "om-forbi");
  }

  // Formuläret i rutnätets rad: sökrutan (Enter), knappen Visa, och requestSubmit från npx-explore.js vid filter
  // och sortering. Körs efter npx-explore.js egen submit-lyssnare, som stänger av tomma fält före en vanlig skickning.
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    slice(form.elements).forEach(function (el) {
      (el.type === "search" || el.tagName === "SELECT") && el.disabled && (el.disabled = !1);
    });
    sokInp && barInp && sokInp.value !== barInp.value && (sokInp.value = barInp.value);
    typFranRutor();
    // telefonens filterlåda stängs när man trycker Visa, så att resultatet syns
    var lada = side && side.classList.contains("is-open"),
      x = side && side.querySelector("[data-npx-side-close]");
    lada && e.submitter && side.contains(e.submitter) && x && x.click();
    kor();
  });

  // Bannerns sökruta: sök på plats och rulla ner till rutnätet. Tom ruta + Enter = alla klipp igen.
  sok &&
    sokInp &&
    sok.addEventListener("submit", function (e) {
      e.preventDefault();
      barInp && (barInp.value = sokInp.value);
      coarse && sokInp.blur(); // telefonens tangentbord fälls ner så att resultatet syns
      kor("fore");
    });

  // Typknapparna: snippets egen lyssnare har redan satt knappen och det dolda fältet.
  typGrupp &&
    typGrupp.addEventListener("click", function (e) {
      var b = e.target.closest("button[data-v]");
      if (!b) return;
      var v = b.getAttribute("data-v");
      rutor().forEach(function (el) {
        el.name === TYP && kryssa(el, el.value === v);
      });
      visaTyp(v);
      kor();
    });

  // Rensa allt: alla filter av, sökordet och sorteringen står kvar.
  // Utforska allt (spaltens rotlänk till startsidan): allt nollställs, även sökordet och sorteringen.
  side &&
    side.addEventListener("click", function (e) {
      var a = e.target.closest(".npx-facets__foot a, a.npx-side-root");
      if (!a || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      rutor().forEach(function (el) {
        el.checked && kryssa(el, !1);
      });
      visaTyp("");
      if (a.classList.contains("npx-side-root")) {
        barInp && (barInp.value = ""), sokInp && (sokInp.value = "");
        sortSel && sortSel.options.length && (sortSel.selectedIndex = 0);
        var lada = side.classList.contains("is-open"),
          x = side.querySelector("[data-npx-side-close]");
        lada && x && x.click();
      }
      kor();
    });

  // Bakåt och framåt: hämta det adressen säger, när den skiljer sig från det som visas.
  window.addEventListener("popstate", function () {
    var nu = utanHash(location.href);
    if (nu === senast) return;
    var u = new URL(nu),
      path = u.pathname.replace(/\/$/, "") || "/",
      arSok = /\/search$/.test(path),
      arAll = /\/collections\/all$/.test(path),
      arHem = path === (hemUrl.replace(/\/$/, "") || "/");
    if (!arSok && !arAll && !arHem) return location.reload();
    var q = arSok ? u.searchParams.get("q") || "" : "",
      s = u.searchParams.get("sort_by") || "";
    barInp && (barInp.value = q), sokInp && (sokInp.value = q);
    sortSel &&
      (sortSel.value = slice(sortSel.options).some(function (o) {
        return o.value === s;
      })
        ? s
        : sortSel.options.length
          ? sortSel.options[0].value
          : "");
    u.searchParams.set("view", "npx");
    senast = nu;
    hamta((arHem ? allUrl : u.pathname) + "?" + u.searchParams.toString(), null, "om-forbi");
  });
})();
